import React, { useMemo } from "react";

import { IFile } from "shared/types";
import { formatDateTime, formatFileSize, getFileIcon } from "shared/utils";
import { FancyFakeLink } from "shared/components/Link/styles";
import { Spacer } from "shared/layout";
import { MutedDarkText } from "shared/styles";
import { copy } from "shared/assets";

import { MainTeaser, TeaserProps } from "./MainTeaser";

interface FileTeaserProps extends IFile, TeaserProps {}

export const FileTeaser: React.FC<FileTeaserProps> = ({
  title,
  source,
  extension,
  size,
  updatedAt,
  description,
  ...rest
}) => {
  const subTitle = useMemo(() => {
    const arr: string[] = [];
    if (extension) arr.push(extension);
    if (size) arr.push(`${formatFileSize(size)}`);
    if (updatedAt) {
      const dateTime = formatDateTime(updatedAt);
      if (dateTime) {
        arr.push(dateTime);
      }
    }
    return arr;
  }, [extension, size, updatedAt]);

  return (
    <MainTeaser
      title={title || ""}
      titleIcon={extension ? getFileIcon(extension) : undefined}
      subTitle={subTitle}
      url={source}
      data-testid="file_teaser"
      {...rest}
    >
      <Spacer size="xs">
        {description && <MutedDarkText>{description}</MutedDarkText>}
        <FancyFakeLink>
          <span>{copy.fileTeaser.cta}</span>
        </FancyFakeLink>
      </Spacer>
    </MainTeaser>
  );
};
